<template>
  <div>
    <div class="carte">
      <ul class="block-btn">
        <li @click="switchDomain" :class="{ active: mode === 3 }"><a>EXPERTISE</a></li>
        <li @click="switchMaps" :class="{ active: mode === 1 }"><a>LOCALISATION</a></li>
        <li @click="switchSector" :class="{ active: mode === 2 }"><a>SECTEUR</a></li>
      </ul>
      <div class="full" v-if="mode === 1">
        <maps @activeSplashScreen="activeSplashScreen" :key="`map-${hackMode}`" v-if="entreprises" :entreprises="entreprises" />
      </div>
      <div class="full" v-if="mode === 2">
        <sector @activeSplashScreen="activeSplashScreen" :key="`sector-${hackMode}`" :secteurs="secteurs" :entreprises="entreprises" :domains="domaines" />
      </div>
      <div class="full" v-if="mode === 3">
        <domain @activeSplashScreen="activeSplashScreen" :key="`domain-${hackMode}`" :domains="domaines" :entreprises="entreprises" :secteurs="secteurs"/>
      </div>
    </div>

    <transition name="fade">
      <div v-if="splashScreen" id="loading-wrapper">
        <div id="loading-content">
          <img :src="logoOccitanie" alt="">
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Maps from './Maps'
import Sector from './Sector'
import Domain from './Domain'
import DataRepository from "../repository/dataRepository"
import logoOccitanie from '../assets/logo-occitanie.png'

export default {
  name: 'Cartographie',
  components: {
    Maps,
    Sector,
    Domain
  },
  data: function () {
    return {
        domaines: null,
        secteurs: null,
        entreprises: null,
        mode: 3,
        hackMode: 0,
        logoOccitanie: logoOccitanie,
        splashScreen: true,
        form: {
          lastName: null,
          firstName: null,
          email: null,
          companyName: null,
          companyLogoUrl: null,
          companySiteUrl: null,
          companyDescription: null,
          companyAddress: null,
          sectorId: null,
          sectorName: null,
          domainId: null,
          domainName: null,
          comment: null,
          otherSector: null,
          otherDomain: null
        }
    }
  },
  async created() {
    await this.fetch()
    this.splashScreen = false
  },
  methods: {
    async fetch() {
      const entreprises = await DataRepository.getEntreprises()
      const secteurs = await DataRepository.getSecteurs()
      const domaines = await DataRepository.getDomaines()

      this.secteurs = secteurs.filter(secteur => secteur.x_business_target_is_in_cartoia)
      this.domaines = domaines.filter(domain => domain.x_activity_domain_is_in_cartoia)
      this.entreprises = entreprises

      this.reloadComponents()
    },
    switchMaps() {
      this.activeSplashScreen()
      this.reloadComponents()
      this.mode = 1;
    },
    switchSector() {
      this.activeSplashScreen()
      this.reloadComponents()
      this.mode = 2;
    },
    switchDomain() {
      this.activeSplashScreen()
      this.reloadComponents()
      this.mode = 3;
    },
    activeSplashScreen() {
      this.splashScreen = true
      window.setTimeout(() => {
        this.splashScreen = false
      }, 350)
    },
    reloadComponents() {
      this.hackMode++
    }
  }

}
</script>

<style>

.container-bubble {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

.btn-retour {
  background-color: #12204c;
  padding: 5px 23px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  margin-bottom: 40px;

}

.btn-retour > span:first-child {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-right: 25px;
}

.btn-retour img {
  transform: rotate(180deg);
  height: 20px;
  margin-right: 12px;
}

.formSubmitCompany label.required:after {
  content: ' *';
  color: red;
}
.loader{
  position: absolute;
  top: calc(50% - 50px);
  left: calc(50% - 50px);
}

.carte {
  position: relative;
  width: 75%;
  margin: 0 auto;
  min-height: 600px;
  background-color: #f7f7f7;
  padding: 20px;
  border-radius: 3px;
}

iframe {
  height: 700px;
}

.block-btn {
  position: absolute;
  top: 42px;
  right: -115px;
  list-style: none;
}

.block-btn li::before {
  content: '';
  width: 13px;
  position: absolute;
  height: 30px;
  top: -2px;
  left: -11px;
  background-color: #ff0033;
  margin-right: 0px;
  border-radius: 3px;
}

.block-btn li {
  margin: 10px 0;
  padding: 7px 10px;
  background-color: #ff0033;
  cursor: pointer;
  position: relative;
  font-size: 13px;
  -webkit-transition: all .2s;
  transition: all .2s;
  border-radius: 3px;
}

.block-btn li:hover {
  background-color: #cc0033;
}

.block-btn li a {
  color: white !important;
}

a {
  text-decoration: none;
}

.full {
  width: 100%;
  height: 100%;
}

.block-btn .active {
  background-color: #ff0033 !important;
}

.block-btn .active::before {
  background-color: #cc0033;
}

.active:hover {
  background-color: #cc0033;
}

.d-flex {
  display: flex;
}

.field {
  margin-top: 20px;
  margin-right: 20px;
  margin-left: 20px;
}

textarea {
  width: 100%;
  height: 150px;
  background-color: white;
  padding-left: 5px;
  outline: none;
  border: 1px solid #eaeaea;
  border-color: rgba(18,32,76,0.25);
}

.form {
  color: #12204c;
  margin: 30px auto;
}

.d-flex .field {
  width: 50%;
}

.field input, .field select{
  width: 100%;
  height: 25px;
  background-color: white;
  padding-left: 5px;
  outline: none;
  border: 1px solid #eaeaea;
  border-color: rgba(18,32,76,0.25);
  border-radius: 2px;
}

.field label {
  text-align: left;
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  /* font-weight: bold; */
}

.button {
  font-family: Gilroy-Bold;
    font-weight: 400;
    font-style: normal;
    letter-spacing: 0px;
    border-width: 0px;
    border-style: solid;
    border-radius: 2px;
    text-transform: uppercase;
    -webkit-transition: all .2s;
    transition: all .2s;
    background: #ff0033;
    color: #ffffff;
    border-color: #ffffff;
    padding: 11px 23px;
    line-height: 16px;
    font-size: 13px;
    margin-top: 10px;
    cursor: pointer;
}

.button:hover {
  background: #cc0033;
}

.container-form {
  background-color: #f7f7f7;
  padding: 20px 12.5%;
  margin-top: 80px;
}

.container-form p {
  color: #12204c;
  font-weight: bold;
}

.separator {
  background: #ff0033;
  border-top-width: 1px;
  margin-bottom: 20px;
  width: 100%;
  height: 1px;
  max-width: 80px;
  margin-top: 30px;
}

.logo {
  margin-left: 12.5%;
  height: 50px;
}

.header {
  padding: 10px 0;
  margin-bottom: 30px;
  background-color: #12204c;
}

#loading-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: #12204c;
  display: flex;
  align-items: center;
  justify-content: center;
}

#loading-content img{
  width: 250px;
  max-width: 100%;
  animation: breathing 1500ms ease-out infinite normal;
}

@-webkit-keyframes breathing {
  0% {
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
  }

  50% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  60% {
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
  }

  80% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  100% {
    -webkit-transform: scale(0.8);
    transform: scale(0.8);
  }
}

@keyframes breathing {
  0% {
    -webkit-transform: scale(0.8);
    -ms-transform: scale(0.8);
    transform: scale(0.8);
  }

  25% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  60% {
    -webkit-transform: scale(0.8);
    -ms-transform: scale(0.8);
    transform: scale(0.8);
  }

  80% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  100% {
    -webkit-transform: scale(0.8);
    -ms-transform: scale(0.8);
    transform: scale(0.8);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 200ms;
}
.fade-enter, .fade-leave-to {
  transition: opacity 300ms;
  opacity: 0;
}


@media (max-width: 1300px) {
  .carte {
    width: 67%;
  }
}

@media (max-width: 1085px) {
  .block-btn {
    display: flex;
    left: 0;
    top: -44px;
    right: 0;
  }

  .carte {
    width: 100%;
    box-sizing: border-box;
    margin-top: 60px;
  }

  .block-btn li {
    margin: 10px 10px;
  }

  .block-btn li::before {
    width: 30px;
    top: 25px;
    left: 11px;
    height: 17px;
  }

  .block-btn .active::before {
    height: 17px;
  }
}

@media (max-width: 520px) {
  .block-btn {
    padding-left: 0;
  }

  .block-btn li {
    width: auto;
    margin: 10px 4px;
    font-size: 13px !important;
  }
}

</style>
